import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import {addItemToCart, removeItemFromCartByArticleNumber} from "../../actions/Cart";
import {getInitialAddonLock, getInitialCartAddons} from "../../selectors/SimpleSelectors";
import {getArticleOptionsInCartList} from "../../selectors/CartUtil";

class ArticleSelection extends Component {

    static propTypes = {
        articleOptions: PropTypes.array.isRequired,
        canClearOnDoubleSelect: PropTypes.bool,
        disableSelection: PropTypes.bool
    }

    static defaultProps = {
        articleOptions: [],
        canClearOnDoubleSelect: false,
        disableSelection: false
    }

    constructor(props) {

        super(props)

        let initialArticle = false
        let defaultOption = false
        let disableSelection = props.disableSelection
        let initialLock = false

        // check if one of the article options is contained in cart
        props.articleOptions.forEach((articleOption) => {

            if (props.initialAddons && props.initialAddons.includes("" + articleOption.value) && props.lockInitialAddons) {
                disableSelection = true
                initialLock = true
            }

            // set default if still empty
            if (("" + articleOption.value).includes('default_')) {
                defaultOption = articleOption.value
                if (!initialArticle) {
                    initialArticle = articleOption.value
                }
            }

            // set cart
            if (props.articleOptionsInCart.includes("" + articleOption.value)) {
                initialArticle = articleOption.value
            }

        })

        this.state = {
            selectedArticle: initialArticle,
            defaultOption: defaultOption,
            initialLock: initialLock,
            selectionLocked: disableSelection,
            selectionInProgress: false
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.disableSelection !== this.state.selectionLocked && !this.state.initialLock) {

            this.setState({
                selectionLocked: nextProps.disableSelection
            })

            // check if items are in cart that are no longer possible to be in cart

            if (nextProps.disableSelection) {
                this.props.articleOptions.forEach((articleOption) => {

                    if (
                        nextProps.articleOptionsInCart.includes("" + articleOption.value)
                        ||
                        this.props.articleOptionsInCart.includes("" + articleOption.value)
                    ) {

                        this.handleArticleDeSelect()

                    }

                })
            }
        }


    }

    componentDidUpdate() {
        if (!this.state.selectionInProgress) {
            if (this.state.selectedArticle !== this.state.defaultOption && this.state.selectedArticle && !this.props.articleOptionsInCart.includes("" + this.state.selectedArticle)) {

                if (this.state.defaultOption) {

                    this.setState({
                        selectedArticle: this.state.defaultOption
                    })

                } else {

                    this.setState({
                        selectedArticle: false
                    })

                }
            }
        }
    }

    handleArticleDeSelect = () => {

        const selectedArticle = this.state.selectedArticle

        if (this.props.cartIsBusy || this.state.selectionLocked || this.state.selectionInProgress) {
            return
        }

        if (selectedArticle !== this.state.defaultOption) {
            this.props.removeItemFromCart("" + selectedArticle)
        }

        if (this.state.defaultOption) {

            this.setState({
                selectedArticle: this.state.defaultOption
            })

        } else {

            this.setState({
                selectedArticle: false
            })

        }
    }

    handleArticleSelect = (clickedArticle) => {

        const selectedArticle = this.state.selectedArticle

        if (this.props.cartIsBusy || this.state.selectionLocked || this.state.selectionInProgress) {
            return
        }

        if (selectedArticle !== clickedArticle) {

            // add item if different article, remove old
            this.setState({
                selectedArticle: clickedArticle,
                selectionInProgress: true
            })

            // unselect previos
            if (selectedArticle !== this.state.defaultOption) {
                this.props.removeItemFromCart("" + this.state.selectedArticle, clickedArticle !== this.state.defaultOption).then((args) => {
                    if (clickedArticle !== this.state.defaultOption) {
                        this.props.addItemToCart("" + clickedArticle).then((args) => {
                            this.setState({selectionInProgress: false})
                        })
                    } else {
                        this.setState({selectionInProgress: false})
                    }
                })
            } else {
                if (clickedArticle !== this.state.defaultOption) {
                    this.props.addItemToCart("" + clickedArticle).then((args) => {
                        this.setState({selectionInProgress: false})
                    })
                } else {
                    this.setState({selectionInProgress: false})
                }
            }

        } else {

            if (clickedArticle !== this.state.defaultOption && this.props.canClearOnDoubleSelect) {
                this.handleArticleDeSelect()
            }

        }

    }

    render() {

        return React.Children.only(
            this.props.children(
                this.handleArticleSelect,
                this.handleArticleDeSelect,
                {...this.state}
            )
        )

    }

}

const mapStateToProps = (state) => {

    return {
        initialAddons: getInitialCartAddons(state),
        lockInitialAddons: getInitialAddonLock(state),
        articleOptionsInCart: getArticleOptionsInCartList(state),
        cartIsBusy: state.cart.isFetching
    }

}

const mapDispatchToProps = (dispatch) => {

    return {
        addItemToCart: (articleNumber) => {
            return dispatch(addItemToCart(articleNumber))
        },
        removeItemFromCart: (articleNumber, isSwapping) => {
            return dispatch(removeItemFromCartByArticleNumber(articleNumber, isSwapping))
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleSelection)



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/ArticleSelection.js
 **/